function Library_form_element(element) {
    this.$element = $(element);
    this.popup = i4_Popup.get(this.$element);

    this.selectors = {
	    formParent: 'form[data-i4-decorator="Validator_form"]',
	    buttonChoose: '.js-button-choose',
	    hiddenAddType: '.js-hidden-add-type',
	    hiddenUploadedFile: '.js-hidden-uploaded-file',
	    documentPreviewChoose: '.js-container-preview-choose',
	    documentPreviewUpload: '.js-link-preview-upload'
    };

    this.data = {
	    elementName: 'element-name',
	    pluginFilemanager: 'plugin-filemanager',
	    pluginDocument: 'plugin-document',
	    targetField: 'target-field'
    };

    this.triggers = {
	    uploadComplete: 'i4:upload-complete',
	    chooseComplete: 'i4:choose-complete',
	    afterLoaded: 'i4:afterLoaded'
    };

    this.init = function() {
	    this.dataPluginFilemanager = this.$element.data(this.data.pluginFilemanager);
	    this.dataPluginDocument = this.$element.data(this.data.pluginDocument);
	    this.dataTargetField = this.$element.data(this.data.targetField);
	    this.dataElementName = this.$element.data(this.data.elementName);

		this.$formParent = this.$element.parents(this.selectors.formParent);
	    this.$buttonChoose = this.$element.find(this.selectors.buttonChoose);
	    this.$hiddenUploadedFile = this.$element.find(this.selectors.hiddenUploadedFile);
	    this.$hiddenChoosedFile = this.$element.find('#'+this.dataTargetField);
	    this.$hiddenAddType = this.$element.find(this.selectors.hiddenAddType);
	    this.$documentPreviewChoose = this.$element.find(this.selectors.documentPreviewChoose);
	    this.$documentPreviewUpload = this.$element.find(this.selectors.documentPreviewUpload);

	    this.$buttonChoose.on('click', this.$onChooseClick.bind(this));
	    this.$hiddenUploadedFile.on(this.triggers.uploadComplete, this.$onUploadChange.bind(this));
	    this.$hiddenChoosedFile.on(this.triggers.chooseComplete, this.$onChooseChange.bind(this));

		this.$formParent.on(this.triggers.afterLoaded, (function() {
			this.updateView();
		}).bind(this));
    };

    this.$onChooseClick = function(event) {
		event.preventDefault();
		i4_Document_listener.set_click_position({top: event.pageY,  left: event.pageX});

		i4_Popup.add()
			.set_option({
				ajax_param: {
					js: this.dataPluginFilemanager,
					call: 'choose_document',
					target_field: this.dataTargetField
				},
		    	position: this.popup ? this.popup : 'cursor',
		    	loader: true
		    })
		    .add_callback('before_remove', (function() {
			    if (this.popup) {
			    	this.popup.show();
			    }
		    }).bind(this))
		    .run();

		if (this.popup) {
			this.popup.hide();
		}
    };

    this.$onUploadChange = function() {
	    // console.log('onUploadChange');

		this.lastType = 'upload';
		this.updateView();
    };

    this.$onChooseChange = function() {
	    // console.log('onChooseChange');
	    this.$documentPreviewChoose = this.$element.find(this.selectors.documentPreviewChoose);

		this.lastType = 'choose';
		this.updateView();
    };

    this.updateView = function() {
	    this.$documentPreviewUpload.hide();
	    this.$documentPreviewChoose.hide();

	    this.$hiddenAddType.val(this.lastType);

	    // console.log('this.lastType', this.lastType);
	    // console.log('this.$documentPreviewChoose', this.$documentPreviewChoose);

	    if (this.lastType === 'upload') {
		    this.$documentPreviewUpload.show();

		    this.$hiddenUploadedFile.attr('name', this.dataElementName);
		    this.$hiddenChoosedFile.attr('name', 'false');

	    } else if (this.lastType === 'choose') {
	    	this.$documentPreviewChoose.show();

	    	this.$hiddenChoosedFile.attr('name', this.dataElementName);
		    this.$hiddenUploadedFile.attr('name', 'false');
	    }

	    // console.log('trigger', this.$element);

	    this.$element.trigger('i4:change');
    };

}
